import {
  getInstagramProfileImage,
  getInstagramReelThumbnail,
  getInstagramReelVideo,
  getLinkForTikTokThumbnail,
  getLinkForTikTokVideo,
  getTikTokProfileImage,
} from '@bounty/utils'
import { CLOUDINARY_URL, VIDEO_BUCKET_URL } from '../config/env'

export const getImageForTikTokVideoId = (videoId: string) => {
  return getLinkForTikTokThumbnail(CLOUDINARY_URL, videoId)
}

export const getVideoForTikTokVideoId = (videoId: string) => {
  return getLinkForTikTokVideo(VIDEO_BUCKET_URL, videoId)
}

export const getImageForInstagramReelContentId = (videoId: string) => {
  return getInstagramReelThumbnail(CLOUDINARY_URL, videoId)
}

export const getVideoForInstagramReelContentId = (videoId: string) => {
  return getInstagramReelVideo(VIDEO_BUCKET_URL, videoId)
}

export const getTikTokProfileImageForUser = (userId: string) => {
  return getTikTokProfileImage(CLOUDINARY_URL, userId)
}

export const getInstagramProfileImageForUser = (userId: string) => {
  return getInstagramProfileImage(CLOUDINARY_URL, userId)
}
